import { render, staticRenderFns } from "./Su.vue?vue&type=template&id=176db568&scoped=true&"
import script from "./Su.vue?vue&type=script&lang=ts&"
export * from "./Su.vue?vue&type=script&lang=ts&"
import style0 from "./Su.vue?vue&type=style&index=0&id=176db568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176db568",
  null
  
)

export default component.exports